<template>
  <default-dialog ref="dia">
    <template v-slot:header>
      <h3>{{ geometryType }}</h3>
    </template>
    <template v-slot:body>
      <div class="markerDialog">
        <div>
          Typ:
          <select name="type" v-model="type">
            <template v-if="geometryType === 'marker'">
              <option v-for="m of markerTypes" :key="m">{{ m }}</option>
            </template>
            <template v-else>
              <option v-for="m of otherTypes" :key="m">{{ m }}</option>
            </template>
          </select>
        </div>
        <div>Name: <input v-model="markerName" /></div>
      </div>
      <div v-if="geometryType === 'polyline' || geometryType === 'polygon'">
        <textarea
          v-model="description"
          placeholder="Die Abfrahrt beginnt..."
        ></textarea>
      </div>
    </template>
    <template v-slot:footer>
      <button @click="cancel">Abbrechen</button>
      <button @click="save">Speichern</button>
    </template>
  </default-dialog>
</template>

<script>
import DefaultDialog from "./DefaultDialog.vue";
export default {
  components: { DefaultDialog },
  methods: {
    async open(feature) {
      console.log("call open for dialog", feature);
      this.geometryType = feature.layerType;
      this.$refs.dia.open();
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    save() {
      this.$refs.dia.cancel();
      return this.resolve({
        save: true,
        type: this.type,
        name: this.markerName,
        description: this.description,
      });
    },
    cancel() {
      this.$refs.dia.cancel();
      return this.resolve({ cancel: true });
    },
  },
  data() {
    return {
      resolve: null,
      type: "",
      markerName: "",
      geometryType: "",
      description: "",
      otherTypes: [
        "freeridetrack",
        "pistentour",
      ],
      markerTypes: [
        "dropzone",
        "lvsSearch",
        "wlan",
        "lvsCheck",
        "noExit",
        "noReturn",
        "parks",
        "restaurant",
        "rodln",
        "gletscherspalte",
        "wildschutz",
        "frInfo",
      ],
    };
  },
};
</script>
<style scoped>
textarea {
  width: 400px;
  height: 200px;
}
</style>